import React from "react";
import { Header as SuiHeader, Container, Segment, Button } from "semantic-ui-react";

const Header = ({ title, link, children }) => (
  <Segment basic compact style={{ paddingLeft: "3em" }}>
    {link}
    <SuiHeader as="h2" content={title} data-test="pageHeader" />
    {children}
  </Segment>
);

const Filter = ({ active, onFilter, children }) => (
  <Button className={active ? "header-tab active-tab" : "header-tab"} onClick={onFilter} style={{ backgroundColor: "#fff" }}>
    {children}
  </Button>
);

const Content = ({ children }) => (
  <Container fluid style={{ backgroundColor: "#ccc", height: "100%" }}>
    <Segment raised style={{ margin: "3em" }}>
      {children}
    </Segment>
  </Container>
);

export const Page = ({ children }) => children;

export default { Page, Header, Content, Filter };
